import React from "react";
import styles from "./LogoCard.module.scss";
import { HeaderLogoType } from "@/types/PageType";
import { MediaItemResponsive } from "../MediaItem/MediaItemResponsive";

interface LogoCardProps {
  show_border_radius: boolean;
  show_box_shadow: boolean;
  element: HeaderLogoType;
  grayscale: boolean;
  cardType?: "slider" | "grid";
  media_format?: {
    mobile: "portrait" | "landscape" | "widescreen" | "square";
    tablet: "portrait" | "landscape" | "widescreen" | "square";
    desktop: "portrait" | "landscape" | "widescreen" | "square";
    fullhd: "portrait" | "landscape" | "widescreen" | "square";
  };
  showBox?: boolean;
  boxBackgroundColor: string;
  skeleton?: boolean;
}

export const LogoCard = ({
  show_border_radius,
  show_box_shadow,
  element,
  grayscale,
  media_format,
  boxBackgroundColor,
  cardType = "slider",
  showBox = false,
  skeleton = false,
}: LogoCardProps) => {
  const skeletonElementClass = skeleton ? "skeleton-element" : "";

  return (
    <div
      data-card-type={cardType}
      data-grayscale={grayscale}
      className={`${styles["logo-element"]} ${showBox ? `is-box-padding ` : ""} ${show_border_radius ? "has-border-radius" : ""} ${show_box_shadow && showBox ? "has-box-shadow" : ""} ${skeletonElementClass}`}
      style={
        showBox && boxBackgroundColor
          ? { background: `var(--${boxBackgroundColor})` }
          : {}
      }
      data-skeleton={skeleton}
    >
      <div
        className={`is-flex is-justify-content-center ${styles["media-wrapper"]}`}
        style={{
          height: `${element.height}%`,
          opacity: skeleton ? 0 : 1,
        }}
      >
        <MediaItemResponsive
          image_desktop={element.image}
          sizes="(max-width: 767px) 100vw, (max-width: 1023px) 50vw, 324px"
          className={`${styles["logo"]}`}
          objectFit="contain"
          mediaFormat={media_format}
          link={element.link}
        />
      </div>
    </div>
  );
};
